<template>
  <!-- 管理员首页 -->
  <div>
    <div>
      <!-- <a-row type="flex" justify="space-between" :gutter="16" style="margin-bottom: 14px;">
        <a-col :span="24">
          <personalOutlaysVue style="height: 200px;" />
        </a-col>
      </a-row>-->
      <a-row type="flex" justify="space-between" :gutter="16">
        <a-col :span="15">
          <briefingBoardVue style="height: 450px;" />
        </a-col>
        <a-col :span="9">
          <approveVue
            @documentsJumped="documentsJumped"
            @approvaled="approvaled"
            @titleClick="titleClick"
            ref="approveVue"
            style="height: 450px;"
          />
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-between" :gutter="16" style="margin-bottom: 14px;">
        <a-col :span="14">
          <secondReceiptAndPaymentVue
            count-position="top"
            echarts-height="280px"
            style="height:400px;width:100%;"
          />
        </a-col>
        <a-col :span="10">
          <secondPaymentPlanVue count-position="top" style="height:400px;width:100%;" />
        </a-col>
      </a-row>
      <a-row
        type="flex"
        justify="space-between"
        :gutter="16"
        style="margin-top: 10px;margin-bottom: 20px;"
      >
        <a-col :span="24">
          <secondProjectLineChartVue style="height:400px;" />
        </a-col>
      </a-row>
      <!-- <a-row type="flex" justify="space-between" :gutter="16" style="margin-top: 4px;">
        <a-col :span="9">
          <receivableInfoVue count-position="top"  echarts-height="280px"/>
        </a-col>
        <a-col :span="7">
          <paymentPlanChartVue style="height: 416px;"/>
        </a-col>
        <a-col :span="8">
          <returnMoneyInfoVue count-position="top" echarts-height="280px"/>
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-between" :gutter="16" style="margin-top: 10px;">
        <a-col :span="12">
          <contractInfoVue/>
        </a-col>
        <a-col :span="12">
          <customerVue style="height: 370px;border-radius:10px;"/>
        </a-col>
      </a-row>-->
      <!--   项目阶段统计已于1.1.3版本中去除   -->
      <!--      <a-row type="flex" justify="space-between" :gutter="16" style="margin-top: 10px;margin-bottom: 20px;">-->
      <!--        <a-col :span="24">-->
      <!--          <projectInfoVue style="background-color:#fff;border-radius:10px;"/>-->
      <!--        </a-col>-->
      <!--      </a-row>-->
    </div>
    <audit
      ref="auditRef"
      :dialog-visible="auditVisible"
      @projectChanges="projectChanges"
      @success="auditSucc"
      @close="auditClose"
    />
    <public-drawer
      ref="publicDrawerRef"
      :title="publicDrawer.title"
      :dialog-visible="publicDrawer.visible"
      :component-name="publicDrawer.comName"
      @projectChanges="publicDialogSucc"
      @close="handleClose"
    />
    <click-view ref="clickViewRef" :dialog-visible="clickViewVisible" @close="clickViewClose" />
  </div>
</template>

<script>
// 模块引入
import approveVue from '@/components/homeComponents/approve.vue' // 审批
import briefingBoardVue from '@/components/homeComponents/briefingBoard.vue' // 简报看板
import personalOutlaysVue from '@/components/homeComponents/personalOutlays.vue' // 个人财年支出
import contractInfoVue from '@/components/homeComponents/contractInfo.vue' // 合同订单统计图表
import internalAnnouncementVue from '@/components/homeComponents/internalAnnouncement.vue' // 内部公告
import paymentPlanChartVue from '@/components/homeComponents/paymentPlanChart.vue' // 付款计划统计
import receivableInfoVue from '@/components/homeComponents/receivableInfo.vue' // 应收款统计图表
import returnMoneyInfoVue from '@/components/homeComponents/returnMoneyInfo.vue' // 回款统计图表
// import projectInfoVue from '@/components/projectStatis/index.vue' // 项目统计图表
import customerVue from '@/components/projectStatis/customerKanBan.vue' // 客户访问数量
import audit from '../approvalManage/approvalData/audit.vue'
import publicDrawer from '../../components/drawer/copyDrawer.vue'
import clickView from '@/components/view/clickView.vue'

import secondReceiptAndPaymentVue from '@/components/homeComponents/second/receiptAndPayment.vue' // 收款统计
import secondPaymentPlanVue from '@/components/homeComponents/second/paymentPlanBieChart.vue' // 付款统计
import secondProjectLineChartVue from '@/components/homeComponents/second/projectLineChart.vue' // 项目数据统计
export default {
  name: 'AdminHome',
  components: {
    approveVue,
    briefingBoardVue,
    personalOutlaysVue,
    contractInfoVue,
    internalAnnouncementVue,
    paymentPlanChartVue,
    receivableInfoVue,
    returnMoneyInfoVue,
    // projectInfoVue,
    customerVue,
    audit,
    publicDrawer,
    clickView,
    secondReceiptAndPaymentVue,
    secondPaymentPlanVue,
    secondProjectLineChartVue
  },
  data () {
    return {
      auditVisible: false,
      userId: '',
      clickViewVisible: false,
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      },
      handlerMap: {
        // 费用报销
        '58': {
          title: this.$tree([], 'financialManage/expenseReim/index'),
          component: 'financialManage/expenseReim/show.vue',
          formSetter: 'reimbursement'
        },
        // 回款计划
        '-13': {
          title: this.$tree([], 'contractManage/paymentPlan/index'),
          component: 'contractManage/paymentPlan/show.vue',
          formSetter: 'payBack'
        },
        //  回款计录
        '13': {
          title: this.$tree([], 'contractManage/paymentRecord/index'),
          component: 'contractManage/paymentRecord/show.vue',
          formSetter: 'payBack'
        },
        // 付款计划
        '-36': {
          title: this.$tree([], 'purchase/paymentSchedule/index'),
          component: 'purchase/paymentSchedule/paymentInfor.vue',
          formSetter: 'payPlan'
        },
        // 付款记录
        '36': {
          title: this.$tree([], 'purchase/paymentRecords/index'),
          component: 'purchase/paymentRecords/recordInform.vue',
          formSetter: 'payPlan'
        },
        '57': {
          title: '预支预付',
          component: 'financialManage/advance/show.vue',
          formSetter: 'prePayment'
        },
        // 采购单
        '21': { // 1
          title: this.$tree([], 'purchase/purchaseNote/index'),
          component: 'contractManage/paymentPlan/show.vue',
          formSetter: 'purchase'
        },
        // 采购申请
        '39': {
          title: this.$tree([], 'purchase/purchaseRequest/index'),
          component: 'purchase/purchaseRequest/show.vue',
          formSetter: 'purchaseRequisition'
        },
        // 收票
        '40': {
          title: this.$tree([], 'financialManage/ticketReceiptRecord/index'),
          component: 'financialManage/ticketReceiptRecord/viewCollection.vue',
          formSetter: 'invoice'
        },
        // 开票
        '27': {
          title: this.$tree([], 'financialManage/billingRecords/index'),
          component: 'financialManage/billingRecords/viewBill.vue',
          formSetter: 'invoice'
        },
        // 合同
        '11': { // 1
          title: this.$tree([], 'contractManage/contractOrder/index'),
          component: 'contractManage/paymentPlan/show.vue',
          formSetter: 'contract'
        },
        // 物资领用
        '12': {
          title: this.$tree([], 'inventory/takeItBack/index'),
          component: 'inventory/takeItBack/details.vue',
          formSetter: 'stockReceiveVo'
        },
        // 退回仓库
        '14': {
          title: this.$tree([], 'inventory/returnWarehouse/index'),
          component: 'inventory/returnWarehouse/details.vue',
          formSetter: 'stockToBack'
        },
        // 项目
        '47': { // 1
          title: this.$tree([], 'projectManage/index'),
          component: 'contractManage/paymentPlan/show.vue',
          formSetter: 'project'
        },
        // 外出
        '333': {
          title: this.$tree([], 'offices/travelRecords/index'),
          component: 'offices/travelRecords/details.vue',
          formSetter: 'outWork'
        },
        // 加班
        '555': {
          title: this.$tree([], 'offices/overtimeRecords/index'),
          component: 'offices/overtimeRecords/details.vue',
          formSetter: 'workOvertime'
        },
        // 节礼
        '666': {
          title: this.$tree([], 'offices/courtesyApplication/index'),
          component: 'offices/courtesyApplication/details.vue',
          formSetter: 'festivalGiftVo'
        },
        // 项目立项申请
        '777': {
          title: this.$tree([], 'projectManage/projectProposals/index'),
          component: 'projectManage/projectProposals/detail.vue',
          formSetter: 'projectApproval'
        },
        // 项目报备
        '888': {
          title: this.$tree([], 'projectManage/laborAndMaterial/index'),
          component: 'projectManage/laborAndMaterial/details.vue',
          formSetter: 'projectReporting'
        },
        // 大额申请
        '999': {
          title: this.$tree([], 'financialManage/largeAmountApplication/index'),
          component: 'financialManage/largeAmountApplication/show.vue',
          formSetter: 'bigAmountApplicationVo'
        },
        // 待办任务
        '15': {
          title: this.$tree([], 'salesOpportunities/todoTask/index'),
          component: 'salesOpportunities/todoTask/details.vue',
          formSetter: 'saleTask'
        },
        // 销售机会
        '16': {
          title: this.$tree([], 'salesOpportunities/projectOpportunities/index'),
          component: 'salesOpportunities/projectOpportunities/details.vue',
          formSetter: 'saleOpportunity'
        },
        // 合同增减
        '17': {
          title: this.$tree([], 'contractManage/contractManagement/index'),
          component: 'contractManage/contractManagement/details.vue',
          formSetter: 'supplement'
        },
        // 招聘申请
        '48': {
          title: this.$tree([], 'manpower/recruitmentDemand/index'),
          component: 'manpower/recruitmentDemand/details.vue',
          formSetter: 'recruitment'
        },
        // 保证金
        '49': {
          title: this.$tree([], 'contractManage/earnestMoney/index'),
          component: 'contractManage/earnestMoney/details.vue',
          formSetter: 'performanceBond'
        },
        // 出车
        '50': {
          title: this.$tree([], 'offices/vehicleDepartureRecord/index'),
          component: 'offices/vehicleDepartureRecord/details.vue',
          formSetter: 'vehicleDepartureRecord'
        },
        '51': {
          title: this.$tree([], 'offices/returnCarRecord/index'),
          component: 'offices/returnCarRecord/details.vue',
          formSetter: 'returnCarRecord'
        }
      },
      handlerDetails: [
        {
          title: this.$tree([], 'financialManage/expenseReim/index'),
          component: 'financialManage/expenseReim/show.vue',
          path: '/reimbursement/getById'
        },
        {
          title: this.$tree([], 'purchase/purchaseNote/index'),
          component: 'purchase/purchaseNote/viewDrawer.vue'
          // path: '/reimbursement/getById'
        },
        {
          title: '预支预付',
          component: 'financialManage/advance/show.vue',
          path: '/prePayment/getById'
        },
        {
          title: this.$tree([], 'contractManage/paymentRecord/index'),
          component: 'contractManage/paymentRecord/show.vue',
          path: '/payBack/getById'
        },
        {
          title: this.$tree([], 'purchase/paymentSchedule/index'),
          component: 'purchase/paymentSchedule/paymentInfor.vue',
          path: '/payPlan/getById'
        },
        {
          title: this.$tree([], 'offices/travelRecords/index'),
          component: 'offices/travelRecords/details.vue',
          path: 'outwork/byId'
        },
        {
          title: this.$tree([], 'offices/overtimeRecords/index'),
          component: 'offices/overtimeRecords/details.vue',
          path: 'outwork/byId'
        },
        {
          title: this.$tree([], 'financialManage/largeAmountApplication/index'),
          component: 'financialManage/largeAmountApplication/show.vue',
          path: 'bigAmount/byId'
        },
        {
          title: this.$tree([], 'projectManage/projectProposals/index'),
          component: 'projectManage/projectProposals/detail.vue',
          path: 'projectApproval/getById'
        },
        {
          title: this.$tree([], 'offices/courtesyApplication/index'),
          component: 'offices/courtesyApplication/details.vue',
          path: '/festivalGift/getById'
        },
        {
          title: this.$tree([], 'inventory/takeItBack/index'),
          component: 'inventory/takeItBack/details.vue',
          path: '/stockReceive/getById'
        },
        {
          title: this.$tree([], 'salesOpportunities/projectOpportunities/index'),
          component: 'salesOpportunities/projectOpportunities/details.vue',
          path: '/saleOpportunity/get'
        },
        {
          title: this.$tree([], 'manpower/recruitmentDemand/index'),
          component: 'manpower/recruitmentDemand/details.vue',
          path: '/recruitment/getById'
        },
        {
          title: this.$tree([], 'contractManage/earnestMoney/index'),
          component: 'contractManage/earnestMoney/details.vue',
          path: '/performance/getById'
        },
        // {
        //   title: this.$tree([], 'contractManage/contractManagement/index'),
        //   component: 'contractManage/contractManagement/details.vue',
        //   path: '/contract/supplement/getById'
        // },
        {
          title: this.$tree([], 'offices/vehicleDepartureRecord/index'),
          component: 'offices/vehicleDepartureRecord/details.vue',
          path: '/outCar/byId'
        },
        {
          title: this.$tree([], 'offices/returnCarRecord/index'),
          component: 'offices/returnCarRecord/details.vue',
          path: '/returnCar/byId'
        }
      ]
    }
  },
  beforeMount () {
    this.userId = this.$store.state.account.user.userId
  },
  methods: {
    noticeTitled (item) {
      if (item === 'seeMore') {
        this.publicDias.visible = true
        this.publicDias.title = this.$tree([], 'system/notice/index')
        this.publicDias.comName = 'system/notice'
      } else {
        this.publicDrawer.title = this.$tree([], 'system/notice/index')
        this.publicDrawer.visible = true
        this.publicDrawer.comName = 'system/notice/noticeDraw.vue'
        this.$nextTick(() => {
          this.$refs.publicDrawerRef.setForm(item)
        })
      }
    },
    publicDialogSucc (value, name) {
      this.openView(value, name)
      // this.publicDrawer.visible = false
    },
    handleClose () {
      this.publicDrawer.visible = false
    },
    auditSucc () {
      this.auditVisible = false
      this.$refs.approveVue.approvalFrtch({ status: 4, userId: this.userId })
    },
    auditClose () {
      this.auditVisible = false
    },
    approvaled (value) {
      this.auditVisible = true
      this.$nextTick(() => {
        this.$refs.auditRef.setId(value)
      })
    },
    // 点击详情
    documentsJumped (item) {
      this.documentsJump(item.rowVal, item.num)
    },
    titleClick (record, num) {
      //
      if (num === 1) {
        if (record.copyType === 21) this.openView(record.purchase, 'purchaseName')
        else if (record.copyType === 11) this.openView(record.contract, 'contractName')
        else if (record.copyType === 47) this.openView(record.project, 'project')
        else if (record.copyType === 58) {
          this.publicDrawer.title = this.$tree([], 'financialManage/expenseReim/index')
          // this.publicDrawer.visible = true
          this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
          this.$get('/reimbursement/getById', { id: record.recordId }).then(res => {
            if (res.data.data) {
              this.publicDrawer.visible = true
              this.$refs.publicDrawerRef.setForm(res.data.data)
            } else {
              this.$message.warning('暂无详情!')
            }
          })
        } else if (record.copyType === 16) {
          this.openView(record.saleOpportunity, 'salesOpportunities')
        } else {
          let hander = this.handlerMap[record.copyType]
          if (hander) {
            this.publicDrawer.title = hander.title
            this.publicDrawer.visible = true
            this.publicDrawer.comName = hander.component
            this.$nextTick(() => {
              try {
                this.$refs.publicDrawerRef.setForm(record[hander.formSetter])
              } catch (error) {

              }
            })
          } else {

          }
        }
      } else {
        this.openView(record, 'customerName')
      }
      this.$refs.publicDrawerRef.isButtonShowFun(1)
    },
    documentsJump (rowVal, num) {
      //
      if (num === 1) {
        let handler = this.handlerDetails[rowVal.checkType]

        if (handler) {
          if (rowVal.checkType === 1) {
            this.publicDrawer.title = handler.title
            this.publicDrawer.visible = true
            this.publicDrawer.comName = handler.component
            this.$nextTick(() => {
              this.$refs.publicDrawerRef.setForm(rowVal.recordId)
            })
          } else if (rowVal.checkType === 3 || rowVal.checkType === 4) {
            if (rowVal.isBack === 0) {
              this.publicDrawer.visible = true
              this.publicDrawer.title = this.$tree([], 'contractManage/paymentRecord/index')
              this.publicDrawer.comName = 'contractManage/paymentRecord/show.vue'
              this.$get('/payBack/getById', { backType: 1, id: rowVal.recordId }).then(res => {
                if (res.data.status === 1) {
                  this.$refs.publicDrawerRef.setForm(res.data.data)
                }
              })
            } else if (rowVal.isBack === 1) {
              this.publicDrawer.visible = true
              this.publicDrawer.title = this.$tree([], 'purchase/paymentSchedule/index')
              this.publicDrawer.comName = 'purchase/paymentSchedule/paymentInfor.vue'
              this.$get('/payPlan/getById', { payType: 0, id: rowVal.recordId }).then(res => {
                if (res.data.status === 1) {
                  this.$refs.publicDrawerRef.setForm(res.data.data)
                }
              })
            }
          } else {
            this.publicDrawer.title = handler.title
            this.publicDrawer.visible = true
            this.publicDrawer.comName = handler.component
            this.$get(handler.path, { id: rowVal.recordId }).then(res => {
              this.$refs.publicDrawerRef.setForm(res.data.data)
            })
          }
        } else {

        }
      } else {
        this.openView(rowVal, 'customerName')
      }
      this.$refs.publicDrawerRef.isButtonShowFun(1)
    },
    // titleClick (record, num) {
    //   if (record.copyType === 58) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'financialManage/expenseReim/index')
    //       // this.publicDrawer.visible = true
    //       this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
    //       this.$get('/reimbursement/getById', {id: record.recordId}).then(res => {
    //         if (res.data.data) {
    //           // this.publicDrawer.title = '费用报销'
    //           this.publicDrawer.visible = true
    //           // this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
    //           this.$refs.publicDrawerRef.setForm(res.data.data)
    //         } else {
    //           this.$message.warning('暂无详情!')
    //         }
    //       })
    //       // this.$nextTick(() => {
    //       //   this.$refs.publicDrawerRef.setForm(record.reimbursement)
    //       // })
    //     } else {
    //       this.openView(record, 'customerName')
    //     }
    //   } else if (record.copyType === -13) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'contractManage/paymentPlan/index')
    //       this.publicDrawer.comName = 'contractManage/paymentPlan/show.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.payBack)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 13) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'contractManage/paymentRecord/index')
    //       this.publicDrawer.comName = 'contractManage/paymentRecord/show.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.payBack)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === -36) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'purchase/paymentSchedule/index')
    //       this.publicDrawer.comName = 'purchase/paymentSchedule/paymentInfor.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.payPlan)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 36) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'purchase/paymentRecords/index')
    //       this.publicDrawer.comName = 'purchase/paymentRecords/recordInform.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.payPlan)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 57) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = '预支预付'
    //       this.publicDrawer.comName = 'financialManage/advance/show.vue'
    //       this.$get('/prePayment/getById', {id: record.prePayment.id}).then(res => {
    //         if (res.data.status === 1) {
    //           this.$nextTick(() => {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           })
    //         }
    //       })
    //       // this.$nextTick(() => {
    //       //   this.$refs.publicDrawerRef.setForm(record.prePayment)
    //       // })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 21) {
    //     if (num === 1) this.openView(record.purchase, 'purchaseName')
    //     else this.openView(record, 'customerName')
    //   } else if (record.copyType === 39) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'purchase/purchaseRequest/index')
    //       this.publicDrawer.comName = 'purchase/purchaseRequest/show.vue'
    //       this.publicDrawer.visible = true
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.purchaseRequisition)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 8) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'financialManage/ticketReceiptRecord/index')
    //       this.publicDrawer.comName = 'financialManage/ticketReceiptRecord/viewCollection.vue'
    //       this.publicDrawer.visible = true
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.invoice)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 27) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'financialManage/billingRecords/index')
    //       this.publicDrawer.comName = 'financialManage/billingRecords/viewBill.vue'
    //       this.publicDrawer.visible = true
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.invoice)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 11) {
    //
    //     if (num === 1) this.openView(record.contract, 'contractName')
    //     else this.openView(record, 'customerName')
    //   } else if (record.copyType === 47) {
    //     if (num === 1) this.openView(record.project, 'project')
    //     else this.openView(record, 'customerName')
    //   } else if (record.copyType === 999) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'financialManage/largeAmountApplication/index')
    //       this.publicDrawer.comName = 'financialManage/largeAmountApplication/show.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.bigAmountApplicationVo)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 888) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'projectManage/laborAndMaterial/index')
    //       this.publicDrawer.comName = 'projectManage/laborAndMaterial/details.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.projectReporting)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 777) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'projectManage/projectProposals/index')
    //       this.publicDrawer.comName = 'projectManage/projectProposals/detail.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.projectApproval)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 666) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'offices/courtesyApplication/index')
    //       this.publicDrawer.comName = 'offices/courtesyApplication/details.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.festivalGiftVo)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 333) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'offices/travelRecords/index')
    //       this.publicDrawer.comName = 'offices/travelRecords/details.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.outWork)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 555) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'offices/overtimeRecords/index')
    //       this.publicDrawer.comName = 'offices/overtimeRecords/details.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.workOvertime)
    //       })
    //     } else this.openView(record, 'customerName')
    //   } else if (record.copyType === 12) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'inventory/takeItBack/index')
    //       this.publicDrawer.comName = 'inventory/takeItBack/details.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(record.stockReceiveVo)
    //       })
    //     } else this.openView(record, 'customerName')
    //   }
    //   this.$refs.publicDrawerRef.isButtonShowFun(1)
    // },
    // documentsJump (rowVal, num) {
    //   if (rowVal.checkType === 0) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'financialManage/expenseReim/index')
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
    //       this.$get('/reimbursement/getById', {id: rowVal.recordId}).then(res => {
    //         this.$refs.publicDrawerRef.setForm(res.data.data)
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 1) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'purchase/purchaseNote/index')
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.comName = 'purchase/purchaseNote/viewDrawer.vue'
    //       this.$nextTick(() => {
    //         this.$refs.publicDrawerRef.setForm(rowVal.recordId)
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 2) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = '预支预付'
    //       this.publicDrawer.comName = 'financialManage/advance/show.vue'
    //       this.$get('/prePayment/getById', {id: rowVal.recordId}).then(res => {
    //         if (res.data.status === 1) {
    //           this.$nextTick(() => {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           })
    //         }
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 3 || rowVal.checkType === 4) {
    //     if (num === 1) {
    //       if (rowVal.isBack === 0) {
    //         this.publicDrawer.visible = true
    //         this.publicDrawer.title = this.$tree([], 'contractManage/paymentRecord/index')
    //         this.publicDrawer.comName = 'contractManage/paymentRecord/show.vue'
    //         this.$get('/payBack/getById', {backType: 1, id: rowVal.recordId}).then(res => {
    //           if (res.data.status === 1) {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           }
    //         })
    //       } else if (rowVal.isBack === 1) {
    //         this.publicDrawer.visible = true
    //         this.publicDrawer.title = this.$tree([], 'purchase/paymentSchedule/index')
    //         this.publicDrawer.comName = 'purchase/paymentSchedule/paymentInfor.vue'
    //         this.$get('/payPlan/getById', {payType: 0, id: rowVal.recordId}).then(res => {
    //           if (res.data.status === 1) {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           }
    //         })
    //       }
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 5) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'offices/travelRecords/index')
    //       this.publicDrawer.comName = 'offices/travelRecords/details.vue'
    //       this.$get('outwork/byId', {id: rowVal.recordId}).then(res => {
    //         if (res.data.status === 1) {
    //           this.$nextTick(() => {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           })
    //         }
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 6) {
    //     if (num === 1) {
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.title = this.$tree([], 'offices/overtimeRecords/index')
    //       this.publicDrawer.comName = 'offices/overtimeRecords/details.vue'
    //       this.$get('outwork/byId', {id: rowVal.recordId}).then(res => {
    //         if (res.data.status === 1) {
    //           this.$nextTick(() => {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           })
    //         }
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 7) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'financialManage/largeAmountApplication/index')
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.comName = 'financialManage/largeAmountApplication/show.vue'
    //       this.$get('bigAmount/byId', {id: rowVal.recordId}).then(res => {
    //         if (res.data.status === 1) {
    //           this.$nextTick(() => {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           })
    //         }
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 8) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'projectManage/projectProposals/index')
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.comName = 'projectManage/projectProposals/detail.vue'
    //       this.$get('projectApproval/getById', {id: rowVal.recordId}).then(res => {
    //         if (res.data.status === 1) {
    //           this.$nextTick(() => {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           })
    //         }
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 9) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'offices/courtesyApplication/index')
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.comName = 'offices/courtesyApplication/details.vue'
    //       this.$get('/festivalGift/getById', {id: rowVal.recordId}).then(res => {
    //         if (res.data.status === 1) {
    //           this.$nextTick(() => {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           })
    //         }
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   } else if (rowVal.checkType === 10) {
    //     if (num === 1) {
    //       this.publicDrawer.title = this.$tree([], 'inventory/takeItBack/index')
    //       this.publicDrawer.visible = true
    //       this.publicDrawer.comName = 'inventory/takeItBack/details.vue'
    //       this.$get('/stockReceive/getById', {id: rowVal.recordId}).then(res => {
    //         if (res.data.status === 1) {
    //           this.$nextTick(() => {
    //             this.$refs.publicDrawerRef.setForm(res.data.data)
    //           })
    //         }
    //       })
    //     } else this.openView(rowVal, 'customerName')
    //   }
    //   this.$refs.publicDrawerRef.isButtonShowFun(1)
    // },
    projectChanges (value, name) {
      // this.publicDia.visible = false
      if (name === 'project') {
        this.$get('/project/list', { id: value.projectId }).then(res => {
          // this.projectInfo = res.data.data.rows[0]
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.openView(res.data.data.rows[0], 'project')
          } else {
            this.$message.warning('未查询到该数据，可能已删除或者没有操作权限，请检查！', 5)
          }
        })
      }
      if (name === 'customerName') this.openView(value, name)
      if (name === 'purchaseName') this.openView(value, name)
      if (name === 'contractName') this.openView(value, name)
      if (name === 'salesOpportunities') this.openView(value, name)
    },
    openView (rowVal, name) {
      this.clickViewVisible = true
      if (name === 'purchaseName') {
        if (rowVal.purchaseId) this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.purchaseId)
        else this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.id)
      } else if (name === 'customerName') {
        this.$refs.clickViewRef.openView('customer', rowVal, rowVal.customerId)
      } else if (name === 'project') {
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
      } else if (name === 'contractName') {
        this.$refs.clickViewRef.openView('contract', rowVal, rowVal.id)
      } else if (name === 'salesOpportunities') {
        this.$refs.clickViewRef.openView('salesOpportunities', rowVal, rowVal.opportunityId)
      }
    },
    clickViewClose () {
      this.clickViewVisible = false
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/roleHome/adminHome.vue